import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MODAL_ROUTES } from '@woolworthsnz/shop';
import { HowWhereWhenPage } from './pages/how-where-when/how-where-when.page';
import { PickupPointInformationModalComponent } from './components/pickup-point-information/pickup-point-information-modal.component';

const routes: Routes = [
	{
		path: '',
		component: HowWhereWhenPage,
		children: [
			{
				path: MODAL_ROUTES.CHANGE_DELIVERY_ADDRESS_PATH,
				outlet: MODAL_ROUTES.HWW_MODAL,
				loadComponent: () => import('./components').then((c) => c.ChangeDeliveryAddressModalComponent),
			},
			{
				path: MODAL_ROUTES.EXPRESS_DELIVERY_FEES_PATH,
				outlet: MODAL_ROUTES.HWW_MODAL,
				loadComponent: () =>
					import('./components/express-fee-modal/express-fees-modal.component').then(
						(c) => c.ExpressFeesModalComponent
					),
			},
			{
				path: MODAL_ROUTES.FLEXIBLE_DELIVERY_FEES_PATH,
				outlet: MODAL_ROUTES.HWW_MODAL,
				loadComponent: () =>
					import('./components/flexible-delivery-fee-modal/flexible-delivery-fees-modal.component').then(
						(c) => c.FlexibleDeliveryFeesModalComponent
					),
			},
			{
				path: MODAL_ROUTES.ADD_DELIVERY_ADDRESS_PATH,
				outlet: MODAL_ROUTES.HWW_MODAL,
				loadComponent: () => import('./components').then((c) => c.AddDeliveryAddressModalComponent),
			},
			{
				path: MODAL_ROUTES.CHANGE_FLEXIBLE_SLOT_PATH,
				outlet: MODAL_ROUTES.HWW_MODAL,
				loadComponent: () => import('./components').then((c) => c.ChangeFlexibleSlotModalComponent),
			},
			{
				path: MODAL_ROUTES.CHANGE_PICK_UP_STORE_PATH,
				outlet: MODAL_ROUTES.HWW_MODAL,
				loadComponent: () => import('./components').then((c) => c.ChangePickupStoreModalComponent),
			},
			{
				path: MODAL_ROUTES.DELIVERY_FEES_PATH,
				outlet: MODAL_ROUTES.HWW_MODAL,
				loadComponent: () => import('./components').then((c) => c.FeesModalComponent),
			},
			{
				path: MODAL_ROUTES.PICKUP_INFORMATION,
				outlet: MODAL_ROUTES.HWW_MODAL,
				loadComponent: () => import('@woolworthsnz/fulfilment').then((c) => c.PickupTypeModalComponent),
			},
			{
				path: MODAL_ROUTES.DIRECT_TO_BOOT_MODAL_PATH,
				outlet: MODAL_ROUTES.HWW_MODAL,
				loadComponent: () => import('./components').then((c) => c.DirectToBootModalComponent),
			},
			{
				path: MODAL_ROUTES.DUAL_OFFER_MODAL_PATH,
				outlet: MODAL_ROUTES.HWW_MODAL,
				loadComponent: () => import('./components').then((c) => c.DualOfferModalComponent),
			},
			{
				path: MODAL_ROUTES.DIRECT_TO_BOOT_GROUPED_MODAL_PATH,
				outlet: MODAL_ROUTES.HWW_MODAL,
				loadComponent: () => import('./components').then((c) => c.DirectToBootGroupedModalComponent),
			},
			{
				path: MODAL_ROUTES.PICKUP_POINT_INFORMATION_MODAL_PATH,
				outlet: MODAL_ROUTES.HWW_MODAL,
				component: PickupPointInformationModalComponent,
			},
		],
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class HowWhereWhenRoutingModule {}
